<template>
  <div class="color">
    <div class="color__box color-filter__checkbox__background" :style="{backgroundColor: hex}"></div>

    <div>
      <!-- <color-search
        v-if="children && children.length >= 5"
        :items="children"
      />
-->
      <!-- <color-tooltip
        v-if="children && children.length < 5"
        :name="name"
        :colors="children"
      /> -->
    </div>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from "vue-class-component"
import { Prop } from 'vue-property-decorator'
// import ColorSearch from '@/components/color-picker/color-search/color-search.vue'
//
@Component({
  components: {
    // ColorTooltip: () => import('@/components/color-picker/color-tooltip/color-tooltip.vue'),
    // 'color-search': ColorSearch,
  },
})
export default class Color extends Vue {
  public isActive: boolean = false
  @Prop() id
  @Prop() hex
  @Prop() name
  @Prop() type
  @Prop() children

  mounted() {
  }


}
</script>
